module.exports = __webpack_public_path__ + "img/staff-p-800.6d5307e0.png";